import { IsJsonString } from '../../utils/isJsonString';
import { ISSERVER } from '../../utils/isServer';

const TokenPersistor = (function () {
  let _serviceName = 'dialaxyAuth';
  let _googleService = 'googleOauthCredential';
  let _providers = 'providers';
  let _state = {};

  _state = _readAll();

  function write(key, value) {
    _state[key] = value;
    _writeAll(JSON.stringify(_state));
  }
  function read(key) {
    return _state[key];
  }
  function remove(key) {
    if (_state[key]) {
      delete _state[key];
      _writeAll(JSON.stringify(_state));
    }
  }
  function _writeAll(value) {
    if (ISSERVER) return _state;
    localStorage.setItem(_serviceName, value);
  }
  function _readAll() {
    if (ISSERVER) return _state;
    const state = localStorage.getItem(_serviceName);
    if (IsJsonString(state)) return JSON.parse(state);
    else return {};
  }

  function purge() {
    if (ISSERVER) return _state;
    localStorage.removeItem(_serviceName);
    localStorage.removeItem(_googleService);
    localStorage.removeItem(_providers);
    _state = {};
  }

  return {
    write,
    read,
    remove,
    purge,
  };
})();
export default TokenPersistor;
